<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="ForecastDateEdit"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="
              d-flex
              justify-content-between
              align-items-center
              flex-wrap
              grid-margin
            "
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start">
                    {{ $t("forecastDateEdit") }}
                  </h6>
                  <button
                    class="btn btn-default float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>

                <div class="card-body">
                  <!--begin::loading-data-->
                  <div v-if="isLoading" class="d-flex align-items-center">
                    <div
                      class="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                    <strong>{{ $t("loadingTxt") }}...</strong>
                  </div>
                  <!--end::loading-data-->
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-baseline
                        mb-2
                      "
                    ></div>

                    <div class="card">
                      <div class="card-body">
                        <h5 class="General">General</h5>
                        <hr>
                        <div class="row mb-3">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("dateFromTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-3">
                            <input
                              type="number"
                              class="form-control"
                              id="date_from"
                              :placeholder="$t('dateFromTxt')"
                              v-model="forms.date_from"
                              required
                            />
                            <div v-if="errors.date_from">
                              <div
                                v-for="error in errors.date_from"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-1">
                            <label for="defaultconfig" class="col-form-label">{{
                              $t("dateToTxt")
                            }}</label>
                          </div>
                          <div class="col-lg-4">
                            <input
                              type="number"
                              class="form-control"
                              id="date_to"
                              :placeholder="$t('dateToTxt')"
                              v-model="forms.date_to"
                            />
                            <div v-if="errors.date_to">
                              <div
                                v-for="error in errors.date_to"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                              >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                        </div>

                       

                       
                      </div>
                    </div>

                    <br />

                    

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import myMixinAddress from '@/middleware/mixinAddress.js';


export default {
  name: "ForecastDateEdit",
  mixins: [myMixinAddress],
  props: {},
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      statustype :["Active","Non Active"],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      permision_role: [],
      fetchCompany: [],
      fetchRegion: [],
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      // company: [],
      // region: [],
      // postalCode: [],
      // countryCode: [],
      // provinceCode: [],
      // cityCode: [],
      // districtCode: [],
      // subDistrictCode: [],
      // fetchSystemCode: [],
      // fetchPostalCode: [],
      // fetchCountryCode: [],
      // featchProvinceCode: [],
      // featchCityCode: [],
      // featchDistrictCode: [],
      // featchSubDistrictCode: [],
      // featchCompany: [],
      forms: [],
      // postal_code: [],
      // country: [],
      // province: [],
      // city: [],
      // district: [],
      // sub_district: [],
      city_type: "",
      type:"",
    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.date_from = "";
      this.forms.date_to = "";
     // this.forms.status = "";
      
       this.status = [];
      // this.region = [];
      // this.type=[];
      // this.postalCode = [];
      // this.countryCode = [];
      // this.provinceCode = [];
      // this.cityCode = [];
      // this.districtCode = [];
      // this.subDistrictCode = [];
      // this.country = [];
      // this.province = [];
      // this.city = [];
      // this.district = [];
      // this.sub_district = [];
      // this.postal_code = [];
      // this.city_type = "";
    },

 
    backForm() {
      window.location.href = "/forecast_date";
    },

    loadData(id) {
      const baseURI = this.$settings.endPoint + "forecast-date/detail/" + id;
      return this.$http.get(baseURI).then((response) => {
        this.forms = response.data.datas;
        this.date_id=this.forms.date_id;
        this.date_from=this.forms.date_from;
        this.date_to=this.forms.date_to;
      
 
        // this.loadProvinceCode(this.country);
        // this.loadCityCode(this.province);
        // this.loadDistrictCode(this.city);
        // this.loadSubDistrictCode(this.district);
        // this.loadPostalCodeOne(this.sub_district);


        // this.form={ name: 'asep', usernmae:res.username };
      });
    },

    loadCompany() {
      const baseURI = this.$settings.endPoint + "company?limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },

    loadCompanyNotLinc() {
      const baseURI =
        this.$settings.endPoint + `company/select`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company?code=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },



    loadSystemCode() {
      const baseURI = this.$settings.endPoint + "system-code?system_code=LOCATION_TYPE";
      return this.$http.get(baseURI).then((response) => {
        this.fetchSystemCode = response.data.datas.data;
      });
    },

    asyncSearchSystemCode(ev) {
      const baseURI = this.$settings.endPoint + "system-code?system_code=LOCATION_TYPE&description=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchRegion = response.data.datas.data;
      });
    },

    asyncSearchCompanyNotLinc(ev) {
      const baseURI =
        this.$settings.endPoint +
        "company/select?code="+ev
        this.companyCode;
      return this.$http.get(baseURI).then((response) => {
        this.fetchCompanyNotLinc = response.data.datas.data;
      });
    },

    // asyncSearchRegion(ev) {
    //   const baseURI = this.$settings.endPoint + "region?region_code=" + ev;

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchRegion = response.data.datas.data;
    //   });
    // },

    // loadRegion() {
    //   const baseURI = this.$settings.endPoint + "region?limit=10";

    //   return this.$http.get(baseURI).then((response) => {
    //     this.fetchRegion = response.data.datas.data;
    //   });
    // },


    
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "ForecastAvailableDateController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_update) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    submitData() {
      this.fade(true);
      console.log(this.forms.date_to);
     if(this.forms.date_from > this.forms.date_to){
      this.error("Date To must be greater than Date From");
     } else if(this.forms.date_to > 31) {
      this.error("Date To Max is 31");
     }
     else {
      const baseURI =
        this.$settings.endPoint + "forecast-date/update/" + this.forms.date_id;
      this.$http
        .put(baseURI, this.forms)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            //this.resetForm();
            this.errors = [];
            this.success(response.data.datas.messages);

            //window.history.back();
            var params = this.$onRandom(this.forms.date_id);
            window.location.href =
              "/forecast_date/detail/" + params + "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
          //this.resetForm();
        });
     }


      

      
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    console.log(params);
    this.loadData(params[0]);
    this.fetchIt();
    // this.loadRegion();
    // this.loadCompany();
    // this.loadCountryCode();
    // this.loadSystemCode();
  },
};
</script>
<style scoped>
</style>